import type { DetailedHTMLProps, HTMLAttributes } from 'react';

export function FlexColumn(props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  return <div {...props} style={{ display: 'flex', flexDirection: 'column', gap: 16, ...props.style }} />;
}

export function FlexRow(props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  return <FlexColumn {...props} style={{ flexDirection: 'row', ...props.style }} />;
}
